import React, { useEffect, useRef, useState } from 'react';

const InToViewWrapper = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    if (!domRef.current) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Only change isVisible if the element is intersecting
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Once the element is visible, we can stop observing it
          observer.unobserve(domRef.current);
        }
      });
    });

    observer.observe(domRef.current);

    // Clean up the observer on unmount
    return () => domRef.current && observer.unobserve(domRef.current);
  }, []);

  return <div ref={domRef}>{isVisible && children}</div>;
};

export default InToViewWrapper;
